import styled from 'styled-components';
import { Button, Badge } from 'antd';

export const StyledHeader = styled.header`
    padding: 0 0 0 4.9em;
    position: relative;

    img {
        width: 120px;
        height: auto;
    }

    @media (max-width: 992px) {
        display: none;
    }
`;

export const StyledButton = styled(Button)`
    border: 0;
    padding: 0;
    font-size: 2em;
    width: 40px;
    height: 40px;
    position: absolute;
    left: .7em;
    line-height: 1;
    margin: 0 !important;

    &:after {
        border-color: #fff !important;
    }

    &:focus {
        box-shadow: none;
    }
`;

export const StyledDot = styled.span`
    position: absolute;
    top: 0;
    left: 0;
`;

export const StyledBadge = styled(Badge)`
    .ant-badge-status-dot {
        width: 10px;
        height: 10px;
        margin: 10px 0 0 10px;
    }

    .ant-badge-status-processing::after {
        border-color: #faad14;
    }
`;
